export class Step10 {
  constructor() {}
  intitule = 'stepper.form.commun.simp.step10';
  getspan9 = 'bloc_commun.simp.getspan9';
  getspan10 = 'bloc_commun.simp.getspan10';
  getdatefindiffusion = 'bloc_commun.simp.getdatefindiffusion';
  getobjetavis = 'bloc_commun.simp.getobjetavis';
  getnomorganisme = 'bloc_commun.simp.getnomorganisme';
  getspan11 = 'bloc_commun.simp.getspan11';
  getspan12 = 'bloc_commun.simp.getspan12';
  getcriteressociaux = 'bloc_commun.simp.getcriteressociaux';
  getspan13 = 'bloc_commun.simp.getspan13';
  getcriteresenvironnementaux = 'bloc_commun.simp.getcriteresenvironnementaux';
  getoui = 'bloc_commun.simp.getoui';
  getnon = 'bloc_commun.simp.getnon';
  getmotclef = 'bloc_commun.simp.getmotclef';

}
